import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import { getBranchList, getCatalogList } from '../setting/services/settingApi'
import api from '../../api/api'
import { saveAs } from 'file-saver';
import { Box, Button, CircularProgress, FormControl, Menu, MenuItem, Select, TextField } from '@mui/material'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { REPORT_CONFIG } from './config'
import { MobileDatePicker } from '@mui/x-date-pickers';
const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function ReportFuelCost() {
    const [branchs, setBranchs] = useState([])
    const [Catalog, setCatalog] = useState([])
    const [CatalogNo, setCatalogNo] = useState('')
    const [BranchNo, setBranchsNo] = useState('')
    const [startDate, setStartDate] = useState(dayjs(new Date()).subtract(1, 'day'))
    const [endDate, setEndDate] = useState(dayjs(new Date()))
    const [reports, setReports] = useState([])
    const [sumValue, setSumValue] = useState()
    const [loadingDownload, setloadingDownload] = useState(false);
    const [loading, setloading] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        getBranchList(null, setBranchs)
        LoadReport()
    }, [])
    function calculateSum() {
        const sumValue = { Qty: 0, Cost: 0 }

        for (const row of reports) {
            sumValue.Qty += +row.Qty
            sumValue.Cost += +row.Cost
        }
        setSumValue(sumValue)
    }
    useEffect(() => {
        calculateSum()
    }, [reports])

    async function getReportFuelCost(body, mode, format) {

        const url = `${REPORT_CONFIG.requests.getReportFuelCost.url}/${mode}`;


        let _params = '';
        let _sdate = '';
        let _edate = '';
        let _format = '';


        if (body.sdate) {
            _sdate = 'sdate=' + body.sdate;
        }
        if (body.edate) {
            _edate = '&edate=' + body.edate;
        }

        if (format) {
            _format = '&format=' + format;
        }
        _params = '?' + _sdate + _edate + _format
        if (mode === 'file') {
            setloadingDownload(true)
            const res = await api.get(url + _params, { responseType: 'arraybuffer' })
            const data = res.data
            if (format) {
                const blob = new Blob([data], { type: 'application/pdf' });
                saveAs(blob, 'รายงานค่าน้ำมันเชื้อเพลิงในการขนส่งเมล็ดพันธุ์ (กมข-30402(1))');

            } else {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, 'รายงานค่าน้ำมันเชื้อเพลิงในการขนส่งเมล็ดพันธุ์ (กมข-30402(1))');
            }
            setloadingDownload(false)
        } else {
            setloading(true)
            const res = await api.get(url + _params)
            const data = res.data.result
            setReports(data)
            setloading(false)
        }

    }
    async function LoadReport() {
        const body = {
            sdate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
            edate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',

        };
        getReportFuelCost(body, 'data');

    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid p-0">
                    <form >
                        <div class="row  no-gutters">

                            <div class="col-12 col-lg-2">
                                <div class="row no-gutters">
                                    <div class="col-12 header-row border-1 ">
                                        ตัวกรอง
                                    </div>
                                </div>
                                <div class="row no-gutters p-2 border-1">

                                    <div class="col-12">

                                        <label class="labelInput">วันที่เริ่มต้น</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '20px', borderRadius: '25px' }}>
                                            <MobileDatePicker
                                                dayOfWeekFormatter={(day) => `${day}`}
                                                value={startDate} onChange={e => setStartDate(e)}
                                                slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: startDate } }}
                                                slots={{
                                                    textField: BrowserInput,
                                                }}
                                            />
                                        </Box>

                                    </div>
                                    <div class="col-12">

                                        <label class="labelInput">วันที่สิ้นสุด</label>

                                        <Box className='backgroundField' sx={{ marginBottom: '20px', borderRadius: '25px' }}>
                                            <MobileDatePicker
                                                dayOfWeekFormatter={(day) => `${day}`}
                                                value={endDate} onChange={e => setEndDate(e)}
                                                slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: endDate } }}
                                                slots={{
                                                    textField: BrowserInput,
                                                }}
                                            />
                                        </Box>
                                    </div>


                                    <div class="col-12">
                                        <Button onClick={LoadReport} disabled={loading ? true : false} variant='contained' className="ButtomSearch">{loading ? <CircularProgress size={'18px'} color="inherit" /> : 'ค้นหา'} </Button>

                                    </div>

                                </div>
                            </div>
                            <div class="col-12 col-lg-10">
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-between header-row border-1 ">
                                        <div>
                                            รายงานค่าน้ำมันเชื้อเพลิงในการขนส่งเมล็ดพันธุ์ (กมข-30402(1))
                                        </div>
                                        <Button variant='contained'
                                            id="basic-button"
                                            aria-controls={open ? 'basic-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            disabled={loadingDownload ? true : false}
                                            onClick={handleClick}>{loadingDownload ? <CircularProgress size={'18px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                            PaperProps={{  
                                                style: {  
                                                  width: 100,  
                                                },
                                            }}
                                        >
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    sdate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
                                                    edate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
                                                };
                                                // setFormat('')
                                                getReportFuelCost(body, 'file')

                                                handleClose()
                                            }}>Excel</MenuItem>
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    sdate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
                                                    edate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
                                                };
                                                // setFormat('pdf')
                                                getReportFuelCost(body, 'file', 'pdf')

                                                handleClose()
                                            }}>Pdf</MenuItem>
                                        </Menu>
                                    </div>

                                </div>
                                <div class="row no-gutters border-1 pt-3">
                                    <div class="report col-12">
                                        <div class="table-responsive-sm" style={{ height: 'auto' }}>
                                            <table class="table table-bordered table-sm table-hover">
                                                <thead class="sticky-thead">


                                                    <tr>
                                                        <th scope="col" rowspan="2">ที่</th>
                                                        <th scope="col" rowspan="2">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                                        <th scope="col" rowspan="2">วัน/เดือน/ปี</th>
                                                        <th scope="col" colspan="3">สถานที่จัดส่ง</th>
                                                        <th scope="col" rowspan="2">ประมาณระยะทางที่จัดส่ง (กิโลเมตร)</th>
                                                        <th scope="col" rowspan="2">พันธุ์</th>
                                                        <th scope="col" rowspan="2">ปริมาณเมล็ดพันธุ์ (กิโลกรัม)</th>
                                                        <th scope="col" rowspan="2">ค่าน้ำมันฯ (บาท)</th>
                                                        <th scope="col" rowspan="2">หมายเหตุ</th>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col" >จังหวัด</th>
                                                        <th scope="col" >อำเภอ</th>
                                                        <th scope="col" >โครงการ (ถ้ามี)</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {reports?.map((report, i) => (

                                                        <tr class="cp">
                                                            <td>{report?.Index}</td>
                                                            <td>{report?.BranchName}</td>
                                                            <td>{dayjs(report?.DeliveryDate).format('DD/MM/BBBB')}</td>
                                                            <td>{report?.Province}</td>
                                                            <td>{report?.District}</td>
                                                            <td>{report?.CampaignName}</td>
                                                            <td class="text-center">{report?.Distance}</td>
                                                            <td class="text-center">{report?.CatalogName}</td>
                                                            <td class="text-center">{report?.Qty.toLocaleString()}</td>
                                                            <td class="text-center">{parseFloat(report?.Cost).toFixed(2)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{report?.Remark}</td>
                                                        </tr>
                                                    ))}

                                                </tbody>
                                                <thead class="sticky-tfooter">
                                                    <tr>
                                                        <th scope="col" colspan="8">รวม</th>
                                                        <th scope="col" >{sumValue?.Qty.toLocaleString()}</th>
                                                        <th scope="col" >{parseFloat(sumValue?.Cost).toFixed(2)
                                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</th>
                                                        <th scope="col" ></th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {
                                    reports.length === 0 &&
                                    <div class="row" >
                                        <div class="col-12">
                                            <div class="not-found">
                                                ไม่พบข้อมูล
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>

                        </div>

                    </form>
                </div>
            </Page>
        </div>
    )
}
